export const SOCKET_NEW_TASKMAP_WITH_CHILD = "SOCKET_NEW_TASKMAP_WITH_CHILD";
export const SOCKET_NEW_TASKMAP = "SOCKET_NEW_TASKMAP";
export const SOCKET_LEAVE_TASKMAP = "SOCKET_LEAVE_TASKMAP";

export const SOCKET_CHANGE_BNB = "SOCKET_CHANGE_BNB";

export const SOCKET_UPDATE_TASKMAP = "SOCKET_UPDATE_TASKMAP";
export const SOCKET_UPDATE_TASKMAP_NOSTATUS = "SOCKET_UPDATE_TASKMAP_NOSTATUS";

export const SOCKET_UPDATE_TASK = "SOCKET_UPDATE_TASK";
export const SOCKET_DELETE_TASKMAP = "SOCKET_DELETE_TASKMAP";

export const MANITIZED_CHANELL_EDITTOR_TEXT = "MANITIZED_CHANELL_EDITTOR_TEXT";

export const NEW_CHANNEL_MESSAGE_SOCKET = "NEW_CHANNEL_MESSAGE_SOCKET";
export const REMOVE_EDDITOR_TEXT = "REMOVE_EDDITOR_TEXT";

export const NEW_TASKMAP_CHANNEL_MESSAGE_SOCKET =
  "NEW_TASKMAP_CHANNEL_MESSAGE_SOCKET";

export const Delete_TASKMAP_CHANNEL_MESSAGE_SOCKET =
  "Delete_TASKMAP_CHANNEL_MESSAGE_SOCKET";

export const NEW_TASK_CHANNEL_MESSAGE_SOCKET =
  "NEW_TASK_CHANNEL_MESSAGE_SOCKET";

export const Delete_TASK_CHANNEL_MESSAGE_SOCKET =
  "Delete_TASK_CHANNEL_MESSAGE_SOCKET";

export const Delete_CHANNEL_MESSAGE_SOCKET = "Delete_CHANNEL_MESSAGE_SOCKET";

export const REACT_BOARD_CHANNEL_MESSAGE = "REACT_BOARD_CHANNEL_MESSAGE";

export const Delete_BOARD_COLUMN_SOCKET = "Delete_BOARD_COLUMN_SOCKET";

export const GET_BOARD_CHANNEL_MESSAGES = "GET_BOARD_CHANNEL_MESSAGES";

export const SET_CHANNEL_MESSAGES_LOADING = "SET_CHANNEL_MESSAGES_LOADING";
export const SET_CHANNEL_MESSAGES_LOADING_FALSE = "SET_CHANNEL_MESSAGES_LOADING_FALSE";

export const GET_BOARD_TASKMAP_CHANNEL_MESSAGES =
  "GET_BOARD_TASKMAP_CHANNEL_MESSAGES";

export const SOCKET_LEAVE_TASKMAP_ROOM = "SOCKET_LEAVE_TASKMAP_ROOM";

export const SOCKET_NEW_CHAT_BOARD_MESSAGE = "SOCKET_NEW_CHAT_BOARD_MESSAGE";
export const SEEN_CHAT_BOARD_MESSAGE = "SEEN_CHAT_BOARD_MESSAGE";

export const CHANGE_TASK_DATES_SUSSECCFULLY = "CHANGE_TASK_DATES_SUSSECCFULLY";

export const NEW_TASK_SOCKET = "NEW_TASK_SOCKET";

export const CHANGE_TASK_STATUS = "CHANGE_TASK_STATUS";

export const CHANGED_TASK_STATUS_SOCKET = "CHANGED_TASK_STATUS_SOCKET";

export const CHANGED_TASK_READY_SOCKET = "CHANGED_TASK_READY_SOCKET";
export const CHANGED_TASKMAP_PRIORITY_SOCKET =
  "CHANGED_TASKMAP_PRIORITY_SOCKET";

export const CHANEL_FILE_UPLOAD_VALUE = "CHANEL_FILE_UPLOAD_VALUE";
export const CHANEL_VOICE_UPLOAD_VALUE = "CHANEL_VOICE_UPLOAD_VALUE";
export const GET_BOARD_COLUMNS = "GET_BOARD_COLUMNS";

export const REMOVED_TASK_SOCKET = "REMOVED_TASK_SOCKET";
export const EDITED_TASK_SOCKET = "EDITED_TASK_SOCKET";
export const EDITED_TASK_DEPENDENCY_SOCKET = "EDITED_TASK_DEPENDENCY_SOCKET";
export const ADD_DEPENDENCY_TASK_SOCKET = "ADD_DEPENDENCY_TASK_SOCKET";

export const USER_CONNECT_BOARDROOM = "USER_CONNECT_BOARDROOM";
export const USER_LEAVE_BOARDROOM = "USER_LEAVE_BOARDROOM";

export const USER_WORKING_TIME_ID = "USER_WORKING_TIME_ID";

export const USER_WORKING_STATUS = "USER_WORKING_STATUS";

export const CHANGE_CURRENT_USER_WORKING_STATUS =
  "CHANGE_CURRENT_USER_WORKING_STATUS";

export const GET_CHECKLIST_TASKMAP = "GET_CHECKLIST_TASKMAP";
export const NEW_CHECKLIST_TASKMAP_ADD = "NEW_CHECKLIST_TASKMAP_ADD";
export const TASKMAP_CHECKLIST_ORDER_CHANGED =
  "TASKMAP_CHECKLIST_ORDER_CHANGED";
export const TASKMAP_CHECKLIST_DELETE = "TASKMAP_CHECKLIST_DELETE";
export const TASKMAP_CHECKLIST_STATUS_CHANGED =
  "TASKMAP_CHECKLIST_STATUS_CHANGED";

export const GET_CHECKLIST_TASK = "GET_CHECKLIST_TASK";
export const NEW_CHECKLIST_TASK_ADD = "NEW_CHECKLIST_TASK_ADD";
export const TASK_CHECKLIST_ORDER_CHANGED = "TASK_CHECKLIST_ORDER_CHANGED";
export const TASK_CHECKLIST_DELETE = "TASK_CHECKLIST_DELETE";
export const TASK_CHECKLIST_STATUS_CHANGED = "TASK_CHECKLIST_STATUS_CHANGED";

export const IMPORT_TASKMAPS = "IMPORT_TASKMAPS";

export const OUT_OF_ARCHIVE_TASK = "OUT_OF_ARCHIVE_TASK";
export const ENTER_IN_ARCHIVE_TASK = "ENTER_IN_ARCHIVE_TASK";

export const OUT_OF_ARCHIVE_TASK_AA = "OUT_OF_ARCHIVE_TASK_AA";
export const ENTER_IN_ARCHIVE_TASK_AA = "ENTER_IN_ARCHIVE_TASK_AA";

export const USER_WORKING_SHARESCREEN_MEID = "USER_WORKING_SHARESCREEN_MEID";

export const USER_WORKING_SHARESCREEN_CALLBACK =
  "USER_WORKING_SHARESCREEN_CALLBACK";

export const USERS_WORKING_ROOMS = "USERS_WORKING_ROOMS";
export const USERS_WORKING_SOCKETID = "USERS_WORKING_SOCKETID";

export const USER_RECIEVE_CALL_SHARE_SCREEN = "USER_RECIEVE_CALL_SHARE_SCREEN";
export const USER_ACCEPTED_CALL_SHARE_SCREEN =
  "USER_ACCEPTED_CALL_SHARE_SCREEN";
export const LEAVE_CALL_SHARE_SCREEN = "LEAVE_CALL_SHARE_SCREEN";
export const PEERS_SHARE_SCREEN_WEBRTC = "PEERS_SHARE_SCREEN_WEBRTC";
export const REMOVE_USERS_WEBRTC = "REMOVE_USERS_WEBRTC";

export const CHANGE_TASKMAP_DATE_GANTT = "CHANGE_TASKMAP_DATE_GANTT";
export const SET_TASK_EISENHOWER = "SET_TASK_EISENHOWER";
export const UPDATE_TASKMAP_TASKDETAIL_GANTT =
  "UPDATE_TASKMAP_TASKDETAIL_GANTT";

export const FORM_ATTENTION_CHANGED = "FORM_ATTENTION_CHANGED";
export const BOARD_ROOM_CHANGED = "BOARD_ROOM_CHANGED";

// Older messages (infinite scroll upward)
export const BOARD_CHANNEL_LOAD_OLDER_REQUEST = "BOARD_CHANNEL_LOAD_OLDER_REQUEST";
export const BOARD_CHANNEL_LOAD_OLDER_SUCCESS = "BOARD_CHANNEL_LOAD_OLDER_SUCCESS";
export const BOARD_CHANNEL_LOAD_OLDER_FAIL = "BOARD_CHANNEL_LOAD_OLDER_FAIL";

export const TASKMAP_CHANNEL_LOAD_OLDER_REQUEST = "TASKMAP_CHANNEL_LOAD_OLDER_REQUEST";
export const TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS = "TASKMAP_CHANNEL_LOAD_OLDER_SUCCESS";
export const TASKMAP_CHANNEL_LOAD_OLDER_FAIL = "TASKMAP_CHANNEL_LOAD_OLDER_FAIL";

// ─── Pomodoro timer ───
export const SET_POMODORO_STATE = "SET_POMODORO_STATE";
